import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../Univ';
function BudgetDetail() {
    // =====================================================
    // STATES
    // =====================================================
    const [rows, setRows] = useState([]);
    const [budgetList, setBudgetList] = useState([]);
    const [dept, setDept] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        budget: '',
        dept: '',
        account: '',
        budget_type: 'Expense',
        budget_mode: 'Operational',
        monthly_budget: '',
        yearly_budget: '',
        q1_budget: '',
        q2_budget: '',
        q3_budget: '',
        q4_budget: '',
        alert_percent: '80',
        remarks: '',
        status: '1',
    });
    // =====================================================
    // FETCH BUDGET DETAILS
    // =====================================================
    function fetchData() {
        axios.get(`${baseUrl}budget-detail/`)
            .then(response => {
                setRows(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    // =====================================================
    // FETCH BUDGET MASTER
    // =====================================================
    function fetchBudget() {
        axios.get(`${baseUrl}budget-master-create/`)
            .then(response => {
                setBudgetList(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    // =====================================================
    // FETCH DEPARTMENT
    // =====================================================
    function fetchDept() {
        axios.get(`${baseUrl}add-dept/`)
            .then(response => {
                setDept(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    // =====================================================
    // USE EFFECT
    // =====================================================
    useEffect(() => {
        fetchData();
        fetchBudget();
        fetchDept();
    }, []);
    // =====================================================
    // INPUT HANDLER
    // =====================================================
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        });
    };
    // =====================================================
    // SUBMIT
    // =====================================================
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append(
            'budget',
            registerFormData.budget
        );
        formData.append(
            'department',
            registerFormData.dept
        );
        formData.append(
            'account',
            registerFormData.account
        );
        formData.append(
            'budget_type',
            registerFormData.budget_type
        );
        formData.append(
            'budget_mode',
            registerFormData.budget_mode
        );
        formData.append(
            'monthly_budget',
            registerFormData.monthly_budget
        );
        formData.append(
            'yearly_budget',
            registerFormData.yearly_budget
        );
        formData.append(
            'q1_budget',
            registerFormData.q1_budget
        );
        formData.append(
            'q2_budget',
            registerFormData.q2_budget
        );
        formData.append(
            'q3_budget',
            registerFormData.q3_budget
        );
        formData.append(
            'q4_budget',
            registerFormData.q4_budget
        );
        formData.append(
            'alert_percent',
            registerFormData.alert_percent
        );
        formData.append(
            'remarks',
            registerFormData.remarks
        );
        formData.append(
            'status',
            registerFormData.status
        );
        axios.post(
            `${baseUrl}budget-detail/`,
            formData
        )
            .then(() => {
                fetchData();
                setRegisterFormData({
                    budget: '',
                    dept: '',
                    account: '',
                    budget_type: 'Expense',
                    budget_mode: 'Operational',
                    monthly_budget: '',
                    yearly_budget: '',
                    q1_budget: '',
                    q2_budget: '',
                    q3_budget: '',
                    q4_budget: '',
                    alert_percent: '80',
                    remarks: '',
                    status: '1',
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
    // =====================================================
    // DATAGRID COLUMNS
    // =====================================================
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 80
        },
        {
            field: 'department_name',
            headerName: 'Department',
            width: 200
        },
        {
            field: 'account',
            headerName: 'Account Head',
            width: 220
        },
        {
            field: 'budget_type',
            headerName: 'Type',
            width: 130
        },
        {
            field: 'budget_mode',
            headerName: 'Mode',
            width: 150
        },
        {
            field: 'monthly_budget',
            headerName: 'Monthly',
            width: 140
        },
        {
            field: 'yearly_budget',
            headerName: 'Yearly',
            width: 140
        },
        {
            field: 'q1_budget',
            headerName: 'Q1',
            width: 110
        },
        {
            field: 'q2_budget',
            headerName: 'Q2',
            width: 110
        },
        {
            field: 'q3_budget',
            headerName: 'Q3',
            width: 110
        },
        {
            field: 'q4_budget',
            headerName: 'Q4',
            width: 110
        },
        {
            field: 'alert_percent',
            headerName: 'Alert %',
            width: 120
        },
        {
            field: 'remarks',
            headerName: 'Remarks',
            width: 250
        },
    ];
    return (
        <section className='container-fluid mt-4'>

            <h3 className='bg-success text-white text-center p-2'>
                Budget Detail Management
            </h3>

            <form onSubmit={submitHandler}>

                <div className='row'>

                    {/* BUDGET */}

                    <div className='col-md-2 mb-2'>

                        <select
                            className='form-control'
                            name='budget'
                            value={registerFormData.budget}
                            onChange={inputHandler}
                        >

                            <option value=''>
                                Select Budget
                            </option>

                            {budgetList.map((row, index) => {
                                return (
                                    <option
                                        key={index}
                                        value={row.id}
                                    >

                                        {row.budget_name}

                                    </option>
                                )
                            })}

                        </select>

                    </div>

                    {/* DEPARTMENT */}

                    <div className='col-md-2 mb-2'>

                        <select
                            className='form-control'
                            name='dept'
                            value={registerFormData.dept}
                            onChange={inputHandler}
                        >

                            <option value=''>
                                Choose Department
                            </option>

                            {dept.map((department, index) => {
                                return (
                                    <option
                                        key={index}
                                        value={department.id}
                                    >

                                        {department.department}

                                    </option>
                                )
                            })}

                        </select>

                    </div>

                    {/* ACCOUNT */}

                    <div className='col-md-2 mb-2'>

                        <select
                            className='form-control'
                            name='account'
                            value={registerFormData.account}
                            onChange={inputHandler}
                        >

                            <option value=''>
                                Select Account
                            </option>

                            {/* REVENUE */}

                            <option value='OP Revenue'>
                                OP Revenue
                            </option>

                            <option value='IP Revenue'>
                                IP Revenue
                            </option>

                            <option value='Lab Revenue'>
                                Lab Revenue
                            </option>

                            <option value='Scan Revenue'>
                                Scan Revenue
                            </option>

                            <option value='Pharmacy Revenue'>
                                Pharmacy Revenue
                            </option>

                            {/* EXPENSE */}

                            <option value='General Expense'>
                                General Expense
                            </option>

                            <option value='Consultant Expense'>
                                Consultant Expense
                            </option>

                            <option value='Salary Expense'>
                                Salary Expense
                            </option>

                            <option value='Electricity Expense'>
                                Electricity Expense
                            </option>

                            <option value='Insurance Expense'>
                                Insurance Expense
                            </option>

                            <option value='Equipment Maintenance'>
                                Equipment Maintenance
                            </option>

                            <option value='Marketing Expense'>
                                Marketing Expense
                            </option>

                        </select>

                    </div>

                    {/* BUDGET TYPE */}

                    <div className='col-md-2 mb-2'>

                        <select
                            className='form-control'
                            name='budget_type'
                            value={registerFormData.budget_type}
                            onChange={inputHandler}
                        >

                            <option value='Expense'>
                                Expense
                            </option>

                            <option value='Revenue'>
                                Revenue
                            </option>

                            <option value='Capital'>
                                Capital
                            </option>

                        </select>

                    </div>

                    {/* BUDGET MODE */}

                    <div className='col-md-2 mb-2'>

                        <select
                            className='form-control'
                            name='budget_mode'
                            value={registerFormData.budget_mode}
                            onChange={inputHandler}
                        >

                            <option value='Operational'>
                                Operational
                            </option>

                            <option value='Strategic'>
                                Strategic
                            </option>

                            <option value='Capex'>
                                CAPEX
                            </option>

                            <option value='Opex'>
                                OPEX
                            </option>

                        </select>

                    </div>

                    {/* MONTHLY */}

                    <div className='col-md-2 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Monthly Budget'
                            name='monthly_budget'
                            value={registerFormData.monthly_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* YEARLY */}

                    <div className='col-md-2 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Yearly Budget'
                            name='yearly_budget'
                            value={registerFormData.yearly_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* Q1 */}

                    <div className='col-md-1 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Q1'
                            name='q1_budget'
                            value={registerFormData.q1_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* Q2 */}

                    <div className='col-md-1 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Q2'
                            name='q2_budget'
                            value={registerFormData.q2_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* Q3 */}

                    <div className='col-md-1 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Q3'
                            name='q3_budget'
                            value={registerFormData.q3_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* Q4 */}

                    <div className='col-md-1 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Q4'
                            name='q4_budget'
                            value={registerFormData.q4_budget}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* ALERT */}

                    <div className='col-md-2 mb-2'>

                        <input
                            type='number'
                            className='form-control'
                            placeholder='Alert %'
                            name='alert_percent'
                            value={registerFormData.alert_percent}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* REMARKS */}

                    <div className='col-md-3 mb-2'>

                        <input
                            type='text'
                            className='form-control'
                            placeholder='Remarks'
                            name='remarks'
                            value={registerFormData.remarks}
                            onChange={inputHandler}
                        />

                    </div>

                    {/* SAVE */}

                    <div className='col-md-2 mb-2'>

                        <button
                            type='submit'
                            className='btn btn-primary w-100'
                        >

                            Save Budget

                        </button>

                    </div>

                </div>

            </form>

            {/* DATAGRID */}

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid

                    className="mt-4"

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}

                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    autoHeight

                    components={{
                        Toolbar: GridToolbar,
                    }}

                />

            </div>

        </section>
    )
}
export default BudgetDetail;